import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import ProductServices from "../../../services/ProductServices";
import LocationServices from "../../../services/LocationServices";
import AssestAddModal from "./AssestAddModal";
import * as XLSX from "xlsx";


const InventoryList = () => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [stockSortDirection, setStockSortDirection] = useState(null);


  // Store access based on the logged-in user's role.
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];

  const isSuperAdmin =
    user?.data?.user?.role === "superAdmin";

  const [stores, setStores] = useState(
    isSuperAdmin ? [] : availableStores
  );

  const [selectedStore, setSelectedStore] = useState(
    isSuperAdmin ? "" : availableStores[0]?._id || ""
  );

  const [storesLoading, setStoresLoading] = useState(false);
  const [storeLoadError, setStoreLoadError] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sort, setsort] = useState(150); // Number of items per page
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState({})
  const [isModelOpen, setIsModelOpen] = useState()
  const [run, setRun] = useState(0)

  // Display row options
  const options = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  // Function to change the displayed data based on pagination
  const changeData = (first, second) => {
    const domData = Array.from(
      document.querySelectorAll("#transactions-data tbody tr")
    );
    domData.forEach((row, index) => {
      if (index >= first && index < second) {
        row.classList.remove("d-none");
      } else {
        row.classList.add("d-none");
      }
    });
  };

  // Fetch data from API and filter based on selectedStore and category name 'asset'
  useEffect(() => {
    if (selectedStore) {
      setLoading(true);
      ProductServices.getInventory(selectedStore)
        .then((response) => {
          console.log(response);
          const allData = response?.data?.data || [];

          // Filter by store first
          const storeFilteredData = allData.filter(
            (item) => item?.store?._id === selectedStore
          );

          // ✅ Further filter by category name 'asset' (case-insensitive)
          const assetFilteredData = storeFilteredData.filter(
            (item) =>
              item?.masterItem?.category?.name?.toLowerCase() === "assets"
          );

          setData(assetFilteredData);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          alert("There is some problem in fetching data!");
          setLoading(false);
        });
    }
  }, [selectedStore, run]);


  // Search and numeric Current Stock sorting.
  useEffect(() => {
    const search = searchTerm.toLowerCase();

    let rows = data.filter(item =>
      !search ||
      String(item?.masterItem?.partNo || "")
        .toLowerCase().includes(search) ||
      String(item?.masterItem?.description || "")
        .toLowerCase().includes(search) ||
      String(item?.masterItem?.category?.name || "")
        .toLowerCase().includes(search)
    );

    if (stockSortDirection) {
      const getStock = item => {
        const value = Number(item?.currentStock);
        return Number.isFinite(value) ? value : 0;
      };

      rows.sort((a, b) =>
        stockSortDirection === "asc"
          ? getStock(a) - getStock(b)
          : getStock(b) - getStock(a)
      );
    }

    activePag.current = 0;
    setTest(0);
    setFilteredData(rows);
  }, [searchTerm, data, stockSortDirection]);

  const handleStockSort = () => {
    setStockSortDirection(previous =>
      previous === "asc" ? "desc" : "asc"
    );
  };

  // Pagination setup
  useEffect(() => {
    if (filteredData.length > 0) {
      changeData(activePag.current * sort, (activePag.current + 1) * sort);
    }
  }, [filteredData, sort]);

  const pagination = Math.ceil(filteredData.length / sort);

  const onClick = (i) => {
    activePag.current = i;
    changeData(activePag.current * sort, (activePag.current + 1) * sort);
    setTest(i);
  };

  const handleSelectChange = (selectedOption) => {
    setsort(selectedOption.value);
    activePag.current = 0;
  };

  // Fetch all stores only for SuperAdmin.
  useEffect(() => {
    if (!isSuperAdmin) return;

    let active = true;

    const loadStores = async () => {
      setStoresLoading(true);
      setStoreLoadError("");

      try {
        const response = await LocationServices.getStore();
        const allStores = response?.data?.data;

        if (!Array.isArray(allStores)) {
          throw new Error("Invalid store list response.");
        }

        if (!active) return;

        setStores(allStores);

        setSelectedStore(previous =>
          allStores.some(store => store._id === previous)
            ? previous
            : allStores[0]?._id || ""
        );
      } catch (error) {
        if (!active) return;

        console.error("Unable to load stores:", error);
        setStores([]);
        setSelectedStore("");
        setStoreLoadError("Unable to load stores. Please refresh.");
      } finally {
        if (active) {
          setStoresLoading(false);
        }
      }
    };

    loadStores();

    return () => {
      active = false;
    };
  }, [isSuperAdmin]);

  const storeOptions = stores.map(store => ({
    value: store._id,
    label: [store.name, store.location]
      .filter(Boolean)
      .join(", ")
  }));

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption?.value || "");
    activePag.current = 0;
    setTest(0);
  };

  const Persentage = (user) => {

    const auth = user?.qtyAuth || 0;  // qtyAuth
    const totalRecive = user?.totalRecive || 0;    // totalRecivequantity
    const transfer = user?.transfer || 0;  // transfer

    if (auth === 0) {
      return 0; // Prevent division by zero
    }

    const finaloutput = ((totalRecive - transfer) / auth) * 100; // Correct percentage calculation
    const roundedPercentage = finaloutput.toFixed(2); // Round to 2 decimal places

    return isNaN(roundedPercentage) ? 0 : roundedPercentage;
  };



  const downloadExcel = () => {
    if (filteredData.length === 0) {
      alert("No data available to download.");
      return;
    }


    // Prepare data for Excel
    const excelData = filteredData.map((item, index) => ({
      "#": activePag.current * sort + index + 1,
      "Part No.": item?.masterItem?.partNo || "N/A",
      "Description": item?.masterItem?.description || "N/A",
      "Authorized": item?.qtyAuth || 0,
      "unit": item?.masterItem?.unit?.name || "N/A",
      "Received": item?.totalRecive || 0,
      "Transferred": item?.transfer || 0,
      "MIV": item?.totalMiv || 0,
      "Transition Qty": item?.transitionQty || 0,
      "Critical Status":
        item?.currentStock <= item?.criticalStockQty
          ? `${item?.criticalStockQty} | Low`
          : item?.criticalStockQty || 0,
      "Current Stock": item?.currentStock || 0,
      "Damage": item?.damage || 0,
      "%": `${Persentage(item)}%`,
    }));

    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `Inventory.xlsx`);
  };

  function handleAmount(currentStock, rate) {
    const stock = currentStock || 0;
    const itemRate = rate || 0;
    return (stock * itemRate).toFixed(2); // formatted to 2 decimal places
  }


  const handleAddAssest = (item) => {
    setSelectedItem(item)
    setIsModelOpen(true)
  }

  return (
    <>
      <AssestAddModal
        item={selectedItem}
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      <div className="row">
        {loading ? (
          <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "200px" }}>
            <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-primary fw-semibold">Inventory Loading...</p>
          </div>
        ) : (
          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">

                      <div className="col-xl-4 col-xxl-4">
                        <label className="form-label ms-2">Search Inventory</label>
                        <input
                          type="text"
                          className="form-control mb-xl-0 mb-3"
                          id="searchInput"
                          placeholder="Search by Part No.or Description"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="col-xl-4 col-xxl-4">
                        <label
                          className="form-label ms-2"
                          htmlFor="asset-store-select"
                        >
                          Select Store
                        </label>

                        <Select
                          inputId="asset-store-select"
                          options={storeOptions}
                          value={
                            storeOptions.find(
                              option => option.value === selectedStore
                            ) || null
                          }
                          onChange={handleStoreChange}
                          placeholder="Select or search store..."
                          isSearchable={true}
                          isClearable={false}
                          isLoading={storesLoading}
                          isDisabled={storesLoading}
                          noOptionsMessage={() => "No matching stores found"}
                          className="custom-react-select mb-3 mb-xl-0"
                        />

                        {storeLoadError && (
                          <div className="text-danger small mt-1">
                            {storeLoadError}
                          </div>
                        )}
                      </div>

                      <div className="col-xl-4 col-xxl-4">
                        <label className="form-label ms-2">Select Display Rows</label>
                        <Select

                          placeholder="Select Display Rows"
                          value={options.find((option) => option.value === sort)}
                          onChange={handleSelectChange}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>Assest Inventory List<span className="badge bg-orange ms-2">{filteredData.length}</span>
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        {user.data.user.role === 'superAdmin' && (

                          <div className="d-flex justify-content-end mb-2">
                            <button
                              className="btn btn-success btn-sm"
                              onClick={downloadExcel}
                            >
                              <i className="fa fa-file-excel me-1"></i>
                              Download Excel
                            </button>
                          </div>
                        )}


                        <div className="scrolltable">
                          <table
                            className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                            id="transactions-data"
                          >
                            <thead
                              className="sticky-table-header"
                            >
                              <tr>
                                <th>#</th>
                                <th>Part No.</th>
                                <th>Description</th>
                                <th>Category</th>
                                <th>Unit</th>
                                <th>Received</th>
                                <th>Transfered</th>
                                <th>Transition Qty</th>

                                <th
                                  aria-sort={
                                    stockSortDirection === "asc"
                                      ? "ascending"
                                      : stockSortDirection === "desc"
                                        ? "descending"
                                        : "none"
                                  }
                                >
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent p-0 text-reset fw-bold"
                                    onClick={handleStockSort}
                                    title="Sort by Current Stock"
                                  >
                                    Current
                                    <br />
                                    Stock{" "}
                                    <span aria-hidden="true">
                                      {stockSortDirection === "asc"
                                        ? "↑"
                                        : stockSortDirection === "desc"
                                          ? "↓"
                                          : "↕"}
                                    </span>
                                  </button>
                                </th>
                                <th>Damage</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Array.isArray(filteredData) && filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                  <tr key={index}>
                                    <td>{activePag.current * sort + index + 1}</td>
                                    <td>{item?.masterItem?.partNo}</td>
                                    <td className="scrollable-description">{item?.masterItem?.description}</td>
                                    <td>{item?.masterItem?.category?.name}</td>
                                    <td>{item?.masterItem?.unit?.name}</td>



                                    <td>{Number.isInteger(item?.totalRecive) ? item?.totalRecive : item?.totalRecive.toFixed(2)}</td>

                                    <td>{item?.transfer}</td>
                                    <td>{item?.transitionQty}</td>

                                    <td>{Number.isInteger(item?.currentStock) ? item?.currentStock : item?.currentStock.toFixed(2)}</td>
                                    <td>{item?.damage || 0}</td>

                                    <td>

                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() => { handleAddAssest(item) }}
                                      >
                                        <i className="fa fa-plus"></i>

                                      </button>
                                    </td>


                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="12">No data available</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {activePag.current * sort + 1} to{" "}
                            {Math.min(
                              filteredData.length,
                              (activePag.current + 1) * sort
                            )}{" "}
                            of {filteredData.length} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link
                              className="paginate_button previous"
                              to="#"
                              onClick={() =>
                                activePag.current > 0 &&
                                onClick(activePag.current - 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-left"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <span>
                              {Array.from({ length: pagination }, (_, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${activePag.current === i ? "current" : ""
                                    }`}
                                  onClick={() => onClick(i)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className="paginate_button next"
                              to="#"
                              onClick={() =>
                                activePag.current + 1 < pagination &&
                                onClick(activePag.current + 1)
                              }
                            >
                              <i
                                className="fa fa-angle-double-right"
                                aria-hidden="true"
                              ></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InventoryList;
